import { InputSwitch } from "primereact/inputswitch";
import { Controller, useFormContext } from "react-hook-form";

interface IVisibilityItem {
  name: string;
  label: string;
  description?: string;
}

const visibilityFlags: IVisibilityItem[] = [
  {
    name: "patientResponsibilityVisible",
    label: "Patient Balance Visible",
    description: "Show patient balance type",
  },
  {
    name: "edVisible",
    label: "ER Visible",
    description: "Show ER type",
  },
  // {
  //   name: "bariatricsVisible",
  //   label: "Bariatrics Visible",
  //   description: "Show bariatrics type",
  // },
  {
    name: "gfeVisible",
    label: "Patient Estimate Visible",
    description: "Show Patient Estimate type",
  },
  {
    name: "bundledVisible",
    label: "Clear Packages Visible",
    description: "Show Clear Packages type",
  },
];

export function OrdersVisibility() {
  const { control } = useFormContext<any>();

  return (
    <div className="flex flex-column gap-4 pb-2">
      <span className="font-medium text-sm mb-2 text-gray-600">
        ORDERS VISIBILITY
      </span>
      {visibilityFlags.map((flag) => (
        <div key={flag.name} className="flex gap-3">
          <Controller
            name={flag.name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <InputSwitch
                inputId={flag.name}
                checked={value || false}
                onChange={(e) => onChange(e.value)}
              />
            )}
          />
          <div className="flex flex-column">
            <span className="font-medium text-sm mb-1">{flag.label}</span>
            {flag.description && (
              <span className="text-sm text-gray-500">{flag.description}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
